<template>
  <div>
    <div class="header">
      <div class="logo">Hazardous Chemicals Management System</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TabsView from './TabsView';
  import Levelbar from './Levelbar';
  import Hamburger from '@/components/Hamburger';
  import changePasswordDialog from '../components/changePassword';
  import img_user from '@/assets/imgs/user.png'

  export default {
    components: {
      Levelbar,
      Hamburger,
      TabsView,
      changePasswordDialog
    },
    data() {
      return {
        img_user,
        dialogChangePasswordFormVisible: false

      }
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'name',
        'username',
        'avatar'
      ])
    },
    methods: {
      handleCommand(command) {
        switch (command) {
          case 'changePassword':
            this.showDialog();
            break;
          case 'logout':
            this.logout();
            break;
        }
      },
      showDialog() {
        this.dialogChangePasswordFormVisible = true;
      },
      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      test(){
        alert(123);
      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload();  // 为了重新实例化vue-router对象 避免bug
        });
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 55px;
    font-size: 22px;
    line-height: 55px;
    color: #fff;
    background: #20a0ff;
    z-index: 1002;
  }
  .header .logo{
    background-image: url(./../../assets/imgs/logo.png);
    float: left;
    width:250px;
    text-align: right;
  }
  .user-info {
    float: right;
    padding-right: 50px;
    font-size: 16px;
    color: #fff;
  }
  .user-info .el-dropdown-link{
    position: relative;
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    color: #fff;
    cursor: pointer;
    vertical-align: middle;
  }
  .user-info .el-dropdown-link-logout{
    position: relative;
    display: inline-block;
    padding-left: 5px;
    color: #fff;
    cursor: pointer;
    vertical-align: middle;
  }
  .user-info .user-logo{
    position: absolute;
    left:0;
    top:15px;
    width:40px;
    height:40px;
    border-radius: 50%;
  }
  .el-dropdown-menu__item{
    text-align: center;
  }


  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
    .errLog-container {
      display: inline-block;
      position: absolute;
      right: 150px;
    }
    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }
    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;
      float: left;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 2px;
        position: relative;
        line-height: 0!important;
        .user-avatar {
          width: 30px;
          height: 30px;
          text-align: center;
          margin: 0 auto;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
        .user-name{
          display: block;
          text-align: center;
          margin: 0 auto;
          font-size: 12px;
          padding-top: 10px;
        }
      }

    }
  }
</style>






// WEBPACK FOOTER //
// Header.vue?5ad45076